export const windscreenWorkShops = [
  {
    "Unique ID": 1138,
    Name: "Eng Hong Welding Workshop Sdn Bhd",
    Address:
      "Lot 738 (Pos 50)\nJalan Jeram Tepi Bakri\n84000 Muar\nJohor Darul Takzim",
    Tel: "06- 986 9244",
    Fax: "06- 986 0999",
    Email: "ehwwsb@hotmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1139,
    Name: "Ah Kum Motor Workshop Sdn Bhd",
    Address:
      "No 10, 12 & 32\nJalan Mutiara Emas 7/4\nTaman Mount Austin\n81100 Johor Bahru\nJohor",
    Tel: "019- 754 7988\n019- 777 8817",
    Fax: "07- 354 5670",
    Email: "ahkummotor@hotmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1140,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.17, Jalan Mengkudu\nTaman Makmur\n83000 Batu Pahat\nJohor",
    Tel: "019- 738 1990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1141,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.3, Jalan Sri Perkasa 2/1\nTaman Tampoi Utama\n81200 Johor Bahru\nJohor",
    Tel: "012- 751 6618",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1142,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.47, Jalan Ros Merah 2/3\nTaman Johor Jaya\n81100 Johor Bahru\nJohor",
    Tel: "016- 713 1190",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1143,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No 322, Jalan Dato Sulaiman\nTaman Century\n80250 Johor Bahru\nJohor",
    Tel: "012- 796 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1144,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "MLO.2965, Jalan Tebrau, \nKampung Bendahara, \n81100 Johor Bahru, \nJohor",
    Tel: "019- 798 9437",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1145,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.36, Jalan Perdana 3/2\nTaman Sri Pulai Perdana 2 \n81300 Johor Bahru\nJohor\n",
    Tel: "012- 766 8574",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1146,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 53, Jalan Baiduri\nTaman Daiman Jaya\n81900 Kota Tinggi\nJohor",
    Tel: "012- 779 9862",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA TINGGI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1147,
    Name: "Kluang Welding Sdn Bhd",
    Address: "17 Jalan Bangau\nHappy Valley\n86000 Kluang\nJohor",
    Tel: "07- 772 3106\n012- 738 9901",
    Fax: "07- 771 3614",
    Email: "kluangwelding@gmail.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1148,
    Name: "Nanmar Motor Service Sdn Bhd (HQ)",
    Address:
      "No. 32, Jalan Seroja 37\nTaman Johor Jaya\n81100 Johor Bahru\nJohor",
    Tel: "07- 355 7952\n07- 351 8890",
    Fax: null,
    Email: "nanmarnms@gmail.com\nnanmarjj1@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1149,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 25-3, Ground Floor\nSusur Kulai 1, Kulai Besar\n81000 Kulai Jaya\nJohor",
    Tel: "07- 663 5690\n016- 721 1133",
    Fax: null,
    Email: "nanmarkulai1@gmail.com",
    Area: "KULAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1150,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 3/1, Jalan Kundang 13\nTaman Bukit Pasir\n83000 Batu Pahat\nJohor",
    Tel: "07- 433 1558",
    Fax: null,
    Email: "nanmar2bp2@gmail.com",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1151,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 3G, Jalan Bestari 12/2\nTaman Nusa Bestari\n81300 Skudai\nJohor",
    Tel: "07- 557 4749",
    Fax: null,
    Email: "nanmarnb@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1152,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 91, Jalan Kebun Teh\nTaman Kebun Teh\n80250 Johor Bahru\nJohor",
    Tel: "07- 333 7118",
    Fax: null,
    Email: "nanmarkebunteh@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1153,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "No 68, Jalan Kiambang\nMasai Baru\n81750 Masai\nJohor",
    Tel: "07- 253 2558",
    Fax: null,
    Email: "nanmarmasai@gmail.com",
    Area: "MASAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1154,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "No.18 Jalan Ronggeng 12\nTaman Skudai Baru\n81300 Skudai\nJohor",
    Tel: "07- 554 8353",
    Fax: null,
    Email: "nanmarskudai1@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1155,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 16 Jalan Setia 1\nPusat Perdagangan Setia\n86200 Simpang Renggam\nJohor",
    Tel: "07- 755 3221",
    Fax: null,
    Email: "nanmarspr@gmail.com",
    Area: "SIMPANG RENGGAM",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1156,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 44 Jalan Tampoi\nKampong Baru Tampoi\n81200 Johor Bahru\nJohor",
    Tel: "07- 232 7579",
    Fax: null,
    Email: "nanmartampoi1@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1157,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No 48, Jalan Kempas Utama 3/1\nTaman Kempas Utama\n81200 Johor Bahru\nJohor",
    Tel: "07- 554 6698",
    Fax: null,
    Email: "nanmarkempas@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1158,
    Name: "Radico Trading Sdn Bhd (HQ)",
    Address:
      "No. 40, Jalan Dedap 13\nTaman Johor Jaya\n81100 Johor Bahru\nJohor",
    Tel: "07- 354 4715\n012- 799 2920",
    Fax: "07- 358 2248",
    Email: "radicotrd@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1159,
    Name: "Sin Lai Heng Sdn Bhd",
    Address: "MBP 140 Lot 1712\nJalan Temenggong Ahmad\n84010 Muar\nJohor",
    Tel: "06- 981 2775\n06- 981 3380",
    Fax: "06- 981 3379",
    Email: "slhwsoh@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1196,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No. 3, Ground Floor\nJalan Aman Satu\nTaman Aman\n86000 Kluang\nJohor",
    Tel: "07- 776 6012\n016- 772 8885",
    Fax: null,
    Email: "nanmarkluang@gmail.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1197,
    Name: "Hong Leong Auto",
    Address:
      "No.7, 8 and 9, Jalan Kundang 13\nTaman Bukit Pasir\n83000 Batu Pahat\nJohor",
    Tel: "07- 432 2924",
    Fax: null,
    Email: "hongleongauto@gmail.com",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1213,
    Name: "Radico Trading Sdn Bhd",
    Address: "45, Jalan Sagu 17\nTaman Daya\n81100 Johor Bahru\nJohor",
    Tel: "07- 3537 988\n07- 3507 894\n012- 799 2880",
    Fax: null,
    Email: "radicotd@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1214,
    Name: "Radico Trading Sdn Bhd",
    Address: "34, Jalan Teratai\nMasai Lama\n81100 Johor Bahru\nJohor",
    Tel: "012- 799 2940",
    Fax: null,
    Email: "radicomasai@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1224,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "Lot 7411C, Jalan Jemaluang\n86800 Mersing\nJohor",
    Tel: "07- 799 8788",
    Fax: null,
    Email: "nanmarmersing@gmail.com",
    Area: "MERSING",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1225,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "37-17G, Jalan Bakri\n84000 Muar\nJohor",
    Tel: "06- 950 1342",
    Fax: null,
    Email: "nanmarmuar1@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1227,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "No 4, Jalan Johor Kiri\nBatu 36, 82000 Pontian\nJohor",
    Tel: "07- 688 4555",
    Fax: null,
    Email: "nanmarpontian@gmail.com",
    Area: "PONTIAN",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1229,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "92, Jalan Buloh Kasap\nTaman Tahang Rimau\n85000 Segamat\nJohor",
    Tel: "07- 932 2258",
    Fax: null,
    Email: "nanmarsegamat@gmail.com",
    Area: "SEGAMAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1234,
    Name: "Dr Cermin Sdn Bhd (HQ)",
    Address:
      "No. 2 , 4 & 6, Jalan Ronggeng 1\nTaman Skudai Baru\n81300 Skudai\nJohor\n",
    Tel: "016- 776 4990\n016- 733 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1258,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 107, Jalan Ros Merah 2/3\nJohor Jaya\n81100 Johor Bahru \nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1259,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. G-107, Jalan Mutiara Emas 10/19\nTaman Mount Austin\n81100 Johor Bahru\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1260,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 23, Jalan Perjiranan 15/1 \nBandar Dato Onn\n81100 Johor Bahru\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1261,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No.55-G, Jalan Mutiara 1/2\nTaman Mutiara Mas \n81300 Skudai\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1262,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 9, Jalan Indah 16/12\nTaman Bukit Indah \n79100 Nusajaya\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "NUSAJAYA",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1263,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No.15-G, Jalan Tembusu 1\nTaman Rinting \n81750 Masai\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "MASAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1268,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.138, Jalan Mersing\n86000 Kluang\nJohor Darul Ta'zim\n",
    Tel: "016- 733 0441",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1269,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.769, Taman Teok\nKulai Besar\nTaman Meranti Johor\n81000 Kulai Jaya\nJohor Darul Ta'zim",
    Tel: "018- 779 6194",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KULAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1270,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.18, Jalan Ara 2\nTaman Rinting \n81750 Masai\nJohor Darul Ta'zim\n",
    Tel: "013- 713 3896",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MASAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1271,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No. 22, Jalan Dato Haji Hassan\n84000 Muar\nJohor Darul Ta'zim\n",
    Tel: "019- 751 4991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1272,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No. 3, Taman Sri Gading\n84000 Muar\nJohor Darul Ta'zim\n\n",
    Tel: "010- 662 9877",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1273,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.9, Jalan Sentral 24\nTaman Nusa Sentral\n79100 Nusajaya\nJohor Darul Ta'zim",
    Tel: "012- 784 6990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "NUSAJAYA",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1274,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.2 Jalan 1\nTaman Lundang \n86400 Parit Raja \nJohor Darul Ta'zim\n",
    Tel: "012- 773 1297",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PARIT RAJA",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1275,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.67, Jalan Cempedak 1\nTaman Kota Masai\n81700 Pasir Gudang\nJohor Darul Ta'zim",
    Tel: "012- 710 7886",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PASIR GUDANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1276,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PTD 577, Jalan Sepakat\nKampung Jaya Sepakat\n81400 Senai\nJohor Darul Ta'zim\n",
    Tel: "016- 330 2697",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SENAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1277,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.7, Jalan Baiduri 1 \nTaman Intan\n 81800 Ulu Tiram\nJohor Darul Ta'zim",
    Tel: "018- 766 5220",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "ULU TIRAM ",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1278,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.1, Jalan Besar\nTaman Sembrong \n83700 Yong Peng\nJohor Darul Ta'zim",
    Tel: "019- 736 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "YONG PENG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1325,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 89, Jalan Bentara 1 \nTaman Ungku Tun Aminah \n81300 Skudai\nJohor Darul Ta'zim",
    Tel: "016- 723 3991",
    Fax: "07- 550 5885",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1326,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 3, Jalan Pembangunan\nTaman Desa Rahmat\n81200 Johor Bahru\nJohor Darul Ta'zim\n",
    Tel: "016- 733 5990",
    Fax: "07- 232 4842",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1327,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "175G, Jalan Nusa Bestari 1/5 \nTaman Nusa Bestari\n81300 Skudai\nJohor Darul Ta'zim\n",
    Tel: "013- 750 6788",
    Fax: "07- 512 5576",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1328,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "G-05, Block 3A\nJalan Mutiara Emas 9/3\nTaman Mount Austin\n81100 Johor Bahru\nJohor Darul Ta'zim",
    Tel: "013- 789 3227",
    Fax: "07- 364 4776",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1329,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 30, Jalan Cendana 13\nTaman Cendana\n81700 Pasir Gudang\nJohor Darul Ta'zim",
    Tel: "012- 778 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PASIR GUDANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1330,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 11 & 11A, Jalan Sinar\nTaman Sinar\n86200 Simpang Renggam\nJohor Darul Ta'zim",
    Tel: "019- 756 1135",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SIMPANG RENGGAM",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1332,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 137, Jalan Pasir Pelangi\nTaman Iskandar\n80050 Johor Bahru\nJohor Darul Ta'zim",
    Tel: "019- 735 7992",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1357,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 71, Jalan Bendara 20\nTaman Ungku Tun Aminah\n81300 Skudai\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1358,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 3-G, Jalan Bestari 1/5\nTaman Nusa Bestari\n81300 Skudai\nJohor Darul Ta'zim",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728\n",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1368,
    Name: "Auto Windshields Sdn Bhd",
    Address: "No 4, Jalan Bestari 14\nMutiara Rini\n8130 Skudai, Johor",
    Tel: "016- 745 8899",
    Fax: null,
    Email: "autowinds@gmail.com",
    Area: "SKUDAI",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 1219,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "4702G, Jalan Sultan Yahya Petra\nTaman Maju\n15200 Kota Bharu\nKelantan",
    Tel: "09- 740 6819",
    Fax: null,
    Email: "nanmarkb@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1281,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT8400, Persiran Wangsa Mewangi\nJalan Gua Musang \n18300 Gua Musang\nKelantan",
    Tel: "012- 912 3830",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "GUA MUSANG",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1282,
    Name: "Dr Cermin Sdn Bhd",
    Address: "PT1953, Mukim Mahang West\nKok Lanas\n16450 Ketereh\nKelantan\n",
    Tel: "012- 933 8578",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KETEREH",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1283,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "S5/2444, Jalan Sultan Yahya Petra\nKubang Kerian\n16150 Kota Bharu \nKelantan\n",
    Tel: "016- 920 3991",
    Fax: "\n",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1284,
    Name: "Dr Cermin Sdn Bhd",
    Address: "35335-B, Jalan Kuala Krai\n15050 Kota Bharu\nKelantan",
    Tel: "019- 927 2990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1285,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT4378/ Lot 3523\nTaman Guchil Jaya \nKawansan Bandar \n18000 Kuala Krai\nKelantan",
    Tel: "012- 918 8037",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA KRAI",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1286,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT 3069, Tingkat Bawah (Blok E)\nJalan Pondok\nKampung Banggol Kerian\n16800 Pasir Puteh\nKelantan",
    Tel: "012- 927 4955",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PASIR PUTEH",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1287,
    Name: "Dr Cermin Sdn Bhd",
    Address: "PT 10859, Jalan Jedok \n17500 Tanah Merah\nKelantan\n",
    Tel: "012- 911 4990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TANAH MERAH",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1340,
    Name: "Dr Cermin Sdn Bhd",
    Address: "570, Jalan Pengkalan Chepa \n15400 Kota Bharu\nKelantan",
    Tel: "019- 954 2990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1341,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 6, Batu 25 1/2\nJalan Depan Sek Men \n18500 Machang\nKelantan",
    Tel: "017- 900 8662",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MACHANG",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1342,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 2623-C, Jalan Pasir Mas Salor\nKg Padang Chenok\n15100 Kota Bharu\nKelantan",
    Tel: "019- 931 2991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1343,
    Name: "Dr Cermin Sdn Bhd",
    Address: "4706-K, Jalan Long Yunus\nTaman Maju\n15200 Kota Bharu\nKelantan",
    Tel: null,
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KOTA BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1344,
    Name: "Dr Cermin Sdn Bhd",
    Address: "PT 2947, Taman Sri Kota 2\n16250 Wakaf Bharu\nKelantan",
    Tel: null,
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "WAKAR BHARU",
    Status: 1,
    State: "Kelantan",
  },
  {
    "Unique ID": 1119,
    Name: "Juta Oven Spray Painting Sdn Bhd",
    Address:
      "No.91 Jalan Timur 6\nKawasan Perusahaan Mergong Barrage\n05050 Alor Setar\nKedah Darul Aman",
    Tel: "04- 733 5715",
    Fax: "04- 733 9668",
    Email: "jutaoven@hotmail.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1120,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "6B, Jalan Lencong Barat\nTaman Dahlia Iii \n05400 Alor Setar\nKedah",
    Tel: "012- 280 9925",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1121,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 5, Jalan Murni\nSeberang Jalan Putra\n05100 Alor Setar\nKedah",
    Tel: "016- 488 0336",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1122,
    Name: "Indah Utara Auto Service Centre Sdn Bhd",
    Address: "No. 80B, KM 10\nJalan Datuk Kumbar\n06500 Alor Setar\nKedah",
    Tel: "04- 735 1707 \n012- 597 1111",
    Fax: null,
    Email: "iuaservice@yahoo.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1123,
    Name: "L.L.S. Motor Workshop Sdn Bhd",
    Address:
      "No A-16, Jalan Fairuz 9/2\nTaman Perusahaan Ringan Bakar Arang\n08000 Sungai Petani\nKedah",
    Tel: "04- 431 0159\n04- 431 0891",
    Fax: "04- 431 0285",
    Email: "llsmwsh@gmail.com",
    Area: "SUNGAI PETANI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1124,
    Name: "U-Lek Motor Sdn Bhd",
    Address: "No 30B, Kampong Sg. Menghulu Batu 2\n07000 Langkawi\nKedah",
    Tel: "04- 966 9193\n012- 494 1949",
    Fax: null,
    Email: "ulek_lgk@yahoo.com",
    Area: "LANGKAWI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1231,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "2, Ground Floor, \nJalan Melati 1, Amanjaya \n08000 Sungai Petani\nKedah",
    Tel: "04- 442 0608",
    Fax: null,
    Email: "nanmarsp@gmail.com",
    Area: "SUNGAI PETANI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1279,
    Name: "Dr Cermin Sdn Bhd",
    Address: "15-15B-15C, \nKolej Utara Commercial Square\n06000 Jitra \nKedah",
    Tel: "019- 400 3992 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JITRA",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1280,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.28, Kompleks Seri Temin\nJalan Ibrahim\n08000 Sungai Petani\nKedah",
    Tel: "012- 498 7991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SUNGAI PETANI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1346,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No 212, Jalan Legenda 8 \nLegenda Heights\n08000 Sungai Petani\nKedah",
    Tel: "016- 416 2990",
    Fax: "04- 424 6043",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SUNGAI PETANI",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 1171,
    Name: "Bengkel Kereta Reliance Sdn Bhd",
    Address:
      "No. 29, Jalan Dua\nOff Chan Sow Lin\nSeksyen 92\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 8488\n03- 9221 6488\n03- 9221 5488\n03- 9221 6162",
    Fax: "03- 9221 2478",
    Email: "btsoo@pc.jaring.my\nbtsoo@relianceautokl.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1172,
    Name: "WTF Auto Services Sdn Bhd",
    Address:
      "No. 23A, Jalan Empat\nOff Jalan Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 3997\n03- 9221 0997\n03- 9221 0998",
    Fax: "03- 9221 7996",
    Email: "tkwong@wtfauto.com.my\ninfo@wtfauto.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1173,
    Name: "A One Windscreen Carcare",
    Address:
      "No. 36 Jalan 7/23A\nJalan Usahawan\nTaman Danau Kota\nSetapak\n53300 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4143 8979\n012- 320 3979",
    Fax: "03- 4143 1979",
    Email: "aonewindscreen@gmail.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1174,
    Name: "BK Auto Glass Trading",
    Address:
      "No. 109, Jalan Besar Kepong\nKepong\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6263 9119\n019- 225 6568",
    Fax: "03- 6276 3573",
    Email: "bkautoglass@gmail.com",
    Area: "KEPONG",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1175,
    Name: "Chua Brothers Windscreen Specialist Sdn Bhd",
    Address:
      "No. 133-G, Jalan Aminuddin Baki\nTaman Tun Dr Ismail\n60000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 7728 0879\n016- 221 9991",
    Fax: "03- 7727 0879",
    Email: "cbws@ymail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1176,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 23, Jalan Pandan Prima 1\nDataran Pandan Prima\n55100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "012- 297 8228",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1177,
    Name: "DSG Auto Glass Sdn Bhd (HQ)",
    Address:
      "No. 27 Ground Floor\nJalan Sarikei\nOff Jalan Pahang\nSetapak\n53000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4021 7798\n016- 331 2798",
    Fax: "03- 4022 2798",
    Email: "claims@dsg-auto.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1178,
    Name: "DW Windscreen Sdn Bhd",
    Address:
      "No. 42, Persiaran Segambut Tengah\nSegambut\n51200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6259 9221\n017- 222 9221",
    Fax: "03- 6259 9225",
    Email: "dw.windscreen@gmail.com",
    Area: "SEGAMBUT",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1179,
    Name: "Fairdeal Auto Cares & Windscreen Services",
    Address:
      "Lot 97, Jalan Pahang\nSetapak\n53000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4023 7870\n016- 338 5684",
    Fax: "03- 4023 7870",
    Email: "fairdealautocares@hotmail.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1180,
    Name: "Hing Seng Autoglass & Accessories",
    Address:
      "No 3, Jalan Dato Haju Harun\nTaynton View, Cheras\n56000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9134 2229\n012- 200 2901",
    Fax: "03- 9130 2901",
    Email: "hingseng2012@hotmail.com",
    Area: "CHERAS",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1181,
    Name: "Kai Windscreen Specialist Sdn Bhd",
    Address:
      "No 5D, Jalan Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 3323\n019- 225 2021",
    Fax: "03- 9221 3323",
    Email: "kaiwindscreen@yahoo.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1182,
    Name: "KL Auto Glass Services (HQ)",
    Address:
      "No. 61, Jalan Kuchai Jaya 1\nOff Jalan Kuchai Lama\nTaman Kuchai Jaya\n58200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 2857 6260\n016- 981 3663",
    Fax: "03- 7980 0744",
    Email: "klautoglass88@hotmail.com \nklautoglass88@gmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1183,
    Name: "Loke Yew Auto Windscreen Specialist",
    Address:
      "No. 80G & 80B\nJalan Loke Yew, Pudu\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9226 2098\n012- 653 7624",
    Fax: "03- 9221 9329",
    Email: "lokeyew.auto@yahoo.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1184,
    Name: "Ming Soon Car Cares Sdn Bhd",
    Address:
      "No.1, Jalan Bukit Permai Utama\nTaman Industri Bukit Permai\n56100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4297 2888\n03- 4297 1818",
    Fax: "03- 4297 9898",
    Email: "mingsooncc_sdnbhd@hotmail.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1185,
    Name: "NS Auto Glass",
    Address:
      "No 468, Jalan Pahang\nSetapak\n53000 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4023 6788\n017- 498 2226",
    Fax: "03- 4023 6687",
    Email: "nsautoglass@yahoo.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1186,
    Name: "Setapak Premier Auto Glass Sdn Bhd",
    Address:
      "No. 430 & 432\nJalan Pahang, Setapak\n53300 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 4024 6926",
    Fax: "03- 4024 7926",
    Email: "setapakpremier@gmail.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1204,
    Name: "Chua Brothers Windscreen Specialist Sdn Bhd",
    Address:
      "No 19, Jalan 3/62A \nBandar Menjalara\n52100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 6270 9633\n012- 676 9633",
    Fax: null,
    Email: "cbwskp@gmail.com",
    Area: "BANDAR MENJALARA",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1206,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd",
    Address:
      "126-0-3 Sri Pelangi Condo\nJalan Genting Klang\n53100 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "016- 975 9666\n016- 378 9090",
    Fax: null,
    Email: "info@dolwa.com.my",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1253,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 54-G, Jalan 1/23A \nTaman Danau Kota\nOff Jalan Genting Klang\n53300 Kuala Lumpur\nWilayah Persekutuan ",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1254,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 35-G, Jalan Metro Perdana Timur 1\nTaman Usahawan Kepong\n52100 Kuala Lumpur\nWilayah Persekutuan ",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KEPONG",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1255,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 91, Taman City\nJalan Kuching\n51200 Kuala Lumpur\nWilayah Persekutuan ",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "JALAN KUCHING",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1256,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 54-G, Jalan Jejaka\nTaman Maluri \n55100 Cheras \nKuala Lumpur\nWilayah Persekutuan ",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "CHERAS",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1257,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 3-G, Jalan Kuchai Maju 2\nOff Jalan Kuchai Lama\n58200 Kuala Lumpur\nWilayah Persekutuan ",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KUCHAI LAMA",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1288,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "80, Jalan 10/118B\nDesa Tun Razak\n56000 Kuala Lumpur\nWilayah Persekutuan ",
    Tel: "012- 356 6732",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "CHERAS",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1289,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT 1, Jalan Besar\nTaman Melawati\n53100 Kuala Lumpur\nWilayah Persekutuan \n\n",
    Tel: "016- 330 3982",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MELAWATI",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1370,
    Name: "DSG Auto Glass Sdn Bhd",
    Address: "No. 218 & 218-1\nJalan Pahang, Setapak\n53000 Kuala Lumpur",
    Tel: "016- 332 7854",
    Fax: null,
    Email: "claims@dsg-auto.com",
    Area: "SETAPAK",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 1134,
    Name: "Uni K.S Mudguard Sdn Bhd",
    Address: "No.54 & 56, Jalan Berkat 8\nTaman Malim Jaya\n75250 Melaka",
    Tel: "06- 335 3091\n06- 335 0092",
    Fax: "06- 335 3091",
    Email: "uniksmudguard@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1135,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "9493, KM 4, Jalan Tun Razak\nOff Jalan Peringgit Jaya\n75100 Melaka",
    Tel: "016- 611 1520",
    Fax: "06- 282 5054",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1136,
    Name: "Sing Kwung Auto Sdn Bhd",
    Address: "Lot 4432, Jalan TTC 6\nKawasan Perindustrian Cheng\n75250 Melaka",
    Tel: "06- 335 8255\n06- 335 5104",
    Fax: "06- 334 0315",
    Email: "ngsinyean@skasb.com.my",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1137,
    Name: "SW Auto Repair",
    Address:
      "No.48, Jalan PPM 13 \nPlaza Pandan Malim Business Park\nBalai Panjang\n75250 Melaka",
    Tel: "012- 607 3921 \n010- 212 3986",
    Fax: "06- 335 6394",
    Email: "swautorepair@ymail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1222,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "5, Jalan KPMB 2\nKompleks Perniagaan Musai Bistari\n75400 Melaka",
    Tel: "06- 264 4199",
    Fax: null,
    Email: "nanmarmelaka@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1223,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "8, Jalan LJ1\nTaman Limbongan Jaya\n75200 Melaka",
    Tel: "06- 264 4137",
    Fax: null,
    Email: "nanmarmelaka2@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1290,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "9493, KM4, Jalan Tun Razak\nOff Jln Peringgit Jaya\n75400 Melaka\n",
    Tel: "016- 611 1520 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MELAKA",
    Status: 0,
    State: "Malacca",
  },
  {
    "Unique ID": 1333,
    Name: "Dr Cermin Sdn Bhd",
    Address: "41A, Jalan Ong Kim Wee\n75300 Melaka",
    Tel: "012- 682 3991",
    Fax: "06- 264 4472",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 1187,
    Name: "Ar Shieng Sdn Bhd",
    Address:
      "T-205, Senawang Light\nJalan Tampin\n70450 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 5984\n06- 677 5985\n06- 677 5986",
    Fax: "06- 678 3966",
    Email: "arshieng@yahoo.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1188,
    Name: "Suen Fatt Workshop Sdn Bhd",
    Address:
      "Lot 30927, Batu 9\nJalan Besar\n71700 Mantin\nNegeri Sembilan Darul Khusus",
    Tel: "06- 758 6333\n06- 758 7333\n06- 758 1364\n06- 758 1563",
    Fax: "06- 758 2821\n06- 758 3563",
    Email: "info@suenfatt.com",
    Area: "MANTIN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1189,
    Name: "Chee Kong Motor Sdn Bhd",
    Address:
      "PT 2103 & 2104, S.H. (D) 71923\nSri Senawang Light Industri Centre\n70450 Seremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 1889\n06- 677 3889",
    Fax: "06- 678 1681\n06- 677 1350",
    Email: "choywan@cheekongmotor.com.my\nckmotor@tm.net.my",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1190,
    Name: "Gopo Auto Supply",
    Address: "89, Jalan Tuanku Antah (Rahang)\n70100 Seremban\nNegeri Sembilan",
    Tel: "06- 767 6388",
    Fax: "06-767 6488",
    Email: "gopoautosupply@hotmail.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1191,
    Name: "Motor Jempol Sdn Bhd",
    Address: "1 ½ Miles, Jalan Kuala Pilah\n72100 Bahau\nNegeri Sembilan",
    Tel: "06- 454 1428",
    Fax: "06-454 5178",
    Email: "mjempol@hotmail.com",
    Area: "BAHAU",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1192,
    Name: "N U Auto Supply Sdn Bhd",
    Address: "No. 66 & 68, Jalan Za'aba\n70100 Seremban\nNegeri Sembilan",
    Tel: "06- 762 6633\n019- 620 9988",
    Fax: "06- 762 6136",
    Email: "nuautosupply@gmail.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1193,
    Name: "Perniagaan Aksesori Kereta S.Klas",
    Address:
      "Lot 9136, Bandar Seremban\nDaerah Seremban\nJalan Tuanku Antah\n70200 Seremban\nNegeri Sembilan",
    Tel: "012- 236 2628\n016- 336 5510",
    Fax: "06- 761 2668",
    Email: "sklas0501@gmail.com\ns_klas@yahoo.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1194,
    Name: "Thian Wah Motor Sdn Bhd",
    Address:
      "No 54 & 55, Jalan Industri 3\nTaman Perindustrian Lukut Indah\n71010 Port Dickson\nNegeri Sembilan",
    Tel: "06- 651 1689",
    Fax: null,
    Email: "thianwah1689@gmail.com",
    Area: "PORT DICKSON",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1230,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "155A, Jalan Tuanku Antah\n70100 Seremban\nNegeri Sembilan",
    Tel: "06- 761 3422",
    Fax: null,
    Email: "nanmarseremban1@gmail.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1264,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 37-G, Jalan Cempaka 28\nPusat Komersial Cempaka, \nSenawang, 70450 Seremban\nNegeri Sembilan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1267,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT3270, Jalan Medang Utama\nTaman Medang\n72100 Bahau\nNegeri Sembilan\n",
    Tel: "013- 652 7392",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BAHAU",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1291,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.174, Jalan Melewar\n72000 Kuala Pilah\nNegeri Sembilan",
    Tel: "019- 224 2990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com\n",
    Area: "KUALA PILAH",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1292,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.7536, Jalan BBN 4/1A, \nTaman Desa Jasmin\nBandar Baru Nilai\n71800 Nilai\nNegeri Sembilan ",
    Tel: "019- 714 6990 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "NILAI",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1293,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.643, Taman Negeri Indah\n71000 Port Dickson \nNegeri Sembilan",
    Tel: "012- 330 3990 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PORT DICKSON",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1294,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.6, Jalan Sri Pagi 1\nTaman Sri Pagi\nSenawang, 70450 Seremban\nNegeri Sembilan",
    Tel: "012- 313 6783",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1295,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.1736, Jalan Rasah \n70300 Seremban\nNegeri Sembilan",
    Tel: "012- 699 3044",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SEREMBAN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1296,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.210, Jalan Seremban\n73000 Tampin\nNegeri Sembilan",
    Tel: "019- 201 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TAMPIN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1338,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PT 3270, Jalan Medang Utama\nTaman Medang\n72100 Bahau\nNegeri Sembilan\n",
    Tel: "013- 652 7392",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BAHAU",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 1160,
    Name: "Hoi Keen Auto Spray Sdn Bhd",
    Address:
      "No. A551, Jalan Padang Lalang\n25050 Kuantan\nPahang Darul Makmur",
    Tel: "09- 516 1898\n09- 516 2471",
    Fax: "09- 516 5898",
    Email: "hoikeenauto@hotmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1161,
    Name: "Car Home (M) Sdn Bhd",
    Address:
      "Lot 18, Jalan Industri Semambu 1\nKawasan Perindustrian Semambu\n 25300 Kuantan\nPahang",
    Tel: "09- 566 8612\n09- 567 8612\n013- 987 3612",
    Fax: "09- 566 5612",
    Email: "carhomemalaysia@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1162,
    Name: "Leong Workshop (Kuantan) Sdn Bhd",
    Address: "D-545 , Jalan Padang Lalang\n25050 Kuantan\nPahang",
    Tel: "013- 923 1398\n013- 927 1398",
    Fax: "09- 558 1399",
    Email: "leongworkshop@yahoo.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1163,
    Name: "Siong Fatt Mudguard Workshop Sdn Bhd",
    Address:
      "No.6 Jalan Industri 1\nTaman Perindustrian Temerloh\n28400 Mentakab\nPahang",
    Tel: "09- 278 3928\n019- 986 2461",
    Fax: "09- 277 0585",
    Email: "sfmwsb2020@gmail.com",
    Area: "MENTAKAB",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1164,
    Name: "Temerloh Majujaya Auto Services Sdn Bhd",
    Address:
      "No. 27-29, Jalan Industri 3/3\nTaman Perindustrian Temerluh\n28400 Mentakab\nPahang",
    Tel: "09- 277 5411\n019- 988 6222",
    Fax: "09- 278 3411",
    Email: "termelohmajujaya@hotmail.com",
    Area: "MENTAKAB",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1198,
    Name: "Car Home (M) Sdn Bhd",
    Address: "A-473 Jalan Tanjung Api\nPadang Lalang\n25050 Kuantan\nPahang",
    Tel: "013- 948 3612\n019- 304 9987",
    Fax: null,
    Email: "carhomemalaysia@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1199,
    Name: "Car Home (M) Sdn Bhd",
    Address:
      "B5, Ground Floor\nJalan Seri Damai Perdana 3\n25050 Kuantan\nPahang",
    Tel: "013- 983 3612",
    Fax: null,
    Email: "carhomemalaysia@gmail.com",
    Area: "KUANTAN",
    Status: 0,
    State: "Pahang",
  },
  {
    "Unique ID": 1221,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "A-6714 GF, Jalan Beserah\n25200 Kuantan\nPahang",
    Tel: "09- 560 6876",
    Fax: null,
    Email: "nanmar1kuantan1@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1232,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "A-2, Ground Floor\nJalan Tengku Ismail\n28000 Temerloh\nPahang",
    Tel: "09- 290 2722",
    Fax: null,
    Email: "nanmartemerloh@gmail.com",
    Area: "TEMERLOH",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1297,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.6, Bentong Heights \n28700 Bentong\nPahang\n",
    Tel: "012- 350 4688",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BENTONG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1298,
    Name: "Dr Cermin Sdn Bhd",
    Address: "16, Indutri Ringan Temin\nJalan Temin\n27000 Jerantut\nPahang",
    Tel: "012- 913 6592",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JERANTUT",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1299,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.5, Jalan Chengal Baru 2\nPusat Perniagaan Chengal\n28000 Temerloh\nPahang",
    Tel: "016- 262 5068",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TEMERLOH",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1300,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.23, Jalan Sri Kerayong 1\nBandar Kerayong\n28300 Triang\nPahang",
    Tel: "012- 977 5990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TRIANG",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1331,
    Name: "Car Home (M) Sdn Bhd (HQ)",
    Address: "A-100, Jalan Berserah\n25300 Kuantan\nPahang",
    Tel: "016- 923 1623\n013- 983 3612",
    Fax: null,
    Email: "carhomemalaysia@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1345,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No. 153, Jalan TC 1\nTaman Cahaya\n27200 Kuala Lipis\nPahang",
    Tel: "019- 319 3997",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA LIPIS",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1363,
    Name: "Mobile Windscreen Sdn Bhd",
    Address: "No. 3, Udarul Aman\nJalan Tun Ismail\n25000 Kuantan\nPahang",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1364,
    Name: "Pacific Auto Care (HQ)",
    Address:
      "18, Ground Floor (Construction Town)\nJalan Putra Square 6\nPutra Square\n25200 Kuantan, Pahang",
    Tel: "09- 5158055",
    Fax: null,
    Email: "autocare.pacific@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1366,
    Name: "Pacific Auto Care",
    Address:
      "B20, Ground Floor\nLorong Padang Permai 47\nPerumahan Padang Permai\n25200 Kuantan, Pahang",
    Tel: "09- 5478055",
    Fax: null,
    Email: "autocare.pacific@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 1125,
    Name: "Chop Chin Hooi Auto Services Sdn Bhd",
    Address:
      "398A, Jalan Taiping\nOff Jalan Perak\n11600 Jelutong\nPulau Pinang",
    Tel: "04- 281 7542\n04- 281 7544",
    Fax: "04- 281 1542",
    Email: "chinhoois@gmail.com\nchinhoois@hotmail.com",
    Area: "JELUTONG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1126,
    Name: "Soon Hin Service & Repair Sdn Bhd",
    Address: "No. 91-K, Jalan Trusan\n10150 George Town\nPulau Pinang",
    Tel: "04- 282 8426",
    Fax: "04- 282 1024",
    Email: "soonhinpg@gmail.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1127,
    Name: "Dr Cermin Sdn Bhd",
    Address: "6004, Jalan Heng Choon Thian\n12100 Butterworth\nPulau Pinang",
    Tel: "016 -470 3938",
    Fax: "04- 333 4310",
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BUTTERWORTH",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1128,
    Name: "Federal Motor",
    Address: "77 & 77A, Lorong Kulit\n10460 George Town\nPulau Pinang",
    Tel: "04- 283 1206\n012- 421 1318",
    Fax: "04- 283 1206",
    Email: "federalmotor1318@gmail.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1129,
    Name: "Kedai Memasang Cermin Kereta Hock Lee Heng (HQ)",
    Address: "No 5954, Jalan Megat Harun\n14000 Bukit Mertajam\nPulau Pinang",
    Tel: "1700- 81- 8892\n04- 530 7852\n04- 538 9716",
    Fax: "04- 538 0518",
    Email: "claims@hockleeheng.com",
    Area: "BUKIT MERTAJAM",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1130,
    Name: "Kedai Memasang Cermin Kereta Hock Lee Heng",
    Address: "No 4961 Jalan Bagan Ajam\n13000 Butterworth\nPulau Pinang",
    Tel: "1700- 81- 8892\n04- 310 7518\n04- 324 4518",
    Fax: "04- 538 0518",
    Email: "claims@hockleeheng.com",
    Area: "BUTTERWORTH",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1131,
    Name: "Shen Wah Auto Services Sdn Bhd",
    Address:
      "No 36, Solok Rawana\nOff Jalan P. Ramlee\n10460 George Town\nPulau Pinang",
    Tel: "04- 281 3072\n012- 579 1188",
    Fax: "04- 281 7101",
    Email: "shenwahautoservices@yahoo.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1132,
    Name: "Speedy Auto Glass Specialists Sdn Bhd",
    Address:
      "No.14, Jalan Perai Jaya\nBandar Perai Jaya\n13700 Seberang Perai\nPulau Pinang",
    Tel: "04- 399 0979\n016- 452 2192",
    Fax: "04- 399 0979",
    Email: "speedyags99@yahoo.com\nspeedyags99@gmail.com",
    Area: "PERAI",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1133,
    Name: "Yan Kee Auto Glass (HQ)",
    Address: "89-1 Jalan P.Ramlee\n10460 George Town\nPulau Pinang",
    Tel: "04- 281 3378\n012- 411 3113",
    Fax: "04- 281 3378",
    Email: "ykag3113@gmail.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1216,
    Name: "Yan Kee Auto Glass",
    Address:
      "17, Jalan Gan Chai Leng\nTaman Chai Leng\n13700 Perai\nPulau Pinang",
    Tel: "04- 3983 378",
    Fax: null,
    Email: "ykag3113@gmail.com",
    Area: "PERAI",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1226,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "92-B-1, Jalan Dato Keramat\n10150 George Town\nPenang",
    Tel: "04- 218 9884",
    Fax: null,
    Email: "nanmarpenang@gmail.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1265,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 87, Jalan Tan Sri The Ewe Lim\nJelutong\n11600 George Town\nPulau Pinang",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "GEORGE TOWN",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1350,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "2343-0, Jalan Permatang Keling\nTaman Sinar\n14300 Nibong Tebal\nPulau Pinang",
    Tel: "013- 476 4991 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "NIBONG TEBAL",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1359,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 11, Jalan Limau Manis 4\nTaman Limau Manis\n14000 Bukit Mertajam\nPulau Pinang",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "BUKIT MERTAJAM",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1373,
    Name: "Kedai Memasang Cermin Kereta Hock Lee Heng",
    Address:
      "No 3314, Jalan Kulim\nCherok Tokun\n14000 Bukit Mertajam\nPulau Pinang",
    Tel: "1700- 81- 8892\n04- 551 7518",
    Fax: "04- 551 7518",
    Email: "claims@hockleeheng.com",
    Area: "BUKIT MERTAJAM",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 1165,
    Name: "Lau Motor Workshop Menglembu (PK) Sdn Bhd",
    Address:
      "Lot 34627\nJalan Hala Perushaan Menglembu 15\nMenglembu \n30200 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 282 6666",
    Fax: "05- 281 6326",
    Email: "laumotor@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1166,
    Name: "Beng Kamunting Auto Service Sdn Bhd",
    Address:
      "Lot 18884, Jalan Perusahaan 8\nKawasan Perusahaan Kamunting\n34600 Kamunting\nPerak Darul Ridzuan",
    Tel: "05- 891 0844\n019- 775 0811",
    Fax: "05- 891 3811",
    Email: "bengkmtg@gmail.com",
    Area: "KAMUNTING",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1167,
    Name: "IAG Auto Glass Specialists",
    Address: "No. 102, Jalan Leong Boon Swee\n31650 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 249 8398\n017- 556 6221",
    Fax: null,
    Email: "ley_1029@hotmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1168,
    Name: "Ipoh Soo Kee Motors Sdn Bhd",
    Address:
      "No 9, Hala Perusahaan Menglembu 4\nKawasan Perusahaan Menglembu\n31450 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 282 2501\n05- 282 1173",
    Fax: "05- 282 7202",
    Email: "iskmsb@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1169,
    Name: "Kg. Tawas Harp Hin Motor Sdn Bhd",
    Address:
      "No. 1, Laluan Kuala Kangsar 9\nOff Jalan Kuala Kangsar\n30010 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 506 4161\n05- 506 6666",
    Fax: "05- 506 4162",
    Email: "kthhm_ngor@yahoo.com.my",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1170,
    Name: "Thim Cheong Enterprise",
    Address:
      "No. 22 & 24 Regat Lahat 1\nOff Lorong Lahat\n30200 Ipoh\nPerak Darul Ridzuan",
    Tel: "05- 241 1402\n012- 519 8881",
    Fax: "05- 254 9170",
    Email: "thimcheong.ent@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1217,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "41-GF, Jalan Leong Boon Swee\nTaman Taiping\n31650 Ipoh\nPerak",
    Tel: "05- 241 0642",
    Fax: null,
    Email: "nanmaripoh@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1266,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 67, Taman Intan Setia \n35900 Tanjong Malim\nPerak Darul Ridzuan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "TANJONG MALIM",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1301,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.25 & 25A, Jalan Peniagaan Sengat \nPusat Perniagaan Sengat\n31350 Ipoh\nPerak\n",
    Tel: "012- 500 1990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1302,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 6, Jalan Assam Kumbang\nAssam Kumbang Taiping\n34000 Taiping\nPerak ",
    Tel: "019- 551 6990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TAIPING",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1303,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No.4, Jalan Slim Lama\n35900 Tanjong Malim\nPerak Darul Ridzuan",
    Tel: "016- 262 5067",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TANJONG MALIM",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1304,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.67 (386)\nJalan Changkat Jong\n36000 Teluk Intan\nPerak Darul Ridzuan",
    Tel: "012- 538 0680",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TELUK INTAN",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1347,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 38A, Jalan Raja Idris\nTaman Raja Idris\n33000 Kuala Kangsar\nPerak Darul Ridzuan\n",
    Tel: "013- 521 6990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA KANGSAR",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1348,
    Name: "Dr Cermin Sdn Bhd",
    Address: "No. 1001, Jalan Intan\n33300 Gerik\nPerak Darul Ridzuan\n",
    Tel: "019- 754 7996",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "GERIK",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1349,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 58, SSN Anjung Tawas\nAnjung Tawas Sinaran\n30010 Ipoh\nPerak Darul Ridzuan",
    Tel: "012- 514 4991 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 1117,
    Name: "PT Yew Motor Sdn Bhd",
    Address:
      "Lot 700, Mile 2\nBintulu Light Industrial Estate\nP.O. Box 515\n97008 Bintulu\nSarawak",
    Tel: "086- 331 631\n019- 854 1288",
    Fax: null,
    Email: "ptyewmotor@ymail.com",
    Area: "BINTULU",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 1118,
    Name: "Hiap Seng Motor Sdn Bhd",
    Address:
      "Lot 1963, Block 4\nPiasau Industrail Estate\nJalan Piasau\n98000 Miri\nSarawak",
    Tel: "085- 654 082",
    Fax: null,
    Email: "hiapsengmtr@gmail.com",
    Area: "MIRI",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 1094,
    Name: "Dynamic Auto Service Centre Sdn Bhd",
    Address:
      "Lot 29, Jalan Balakong\nBatu 11 Cheras\n43200 Kajang\nSelangor Darul Ehsan",
    Tel: "03- 9074 0516\n03- 9074 1516",
    Fax: "03- 9074 2516",
    Email: "dasc1388@gmail.com",
    Area: "KAJANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1095,
    Name: "Hikmat Selesa Sdn Bhd",
    Address:
      "Lot 1635, Jalan Haji Tarmidi\nRantau Panjang\n41200 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3291 2606",
    Fax: "03- 3291 1606",
    Email: "hikmatselesasb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1096,
    Name: "Rawang Yee Motor Sdn Bhd",
    Address:
      "Lot 1 , Jalan Perindustrian 1\nKawasan Perindustrian PKNS, Batu 20\n48000 Rawang\nSelangor Darul Ehsan",
    Tel: "03- 6091 6250\n012-221 6250\n012-335 6250",
    Fax: "03- 6092 6250",
    Email: "claim@rwyeemotor.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1097,
    Name: "Skys Auto Workshop Sdn Bhd",
    Address:
      "No.2 Jalan Utama 2/15\nTaman Perindustrain Puchong Utama\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 8068 3122\n03- 8062 2122",
    Fax: "03- 8068 2122",
    Email: "skysauto@hotmail.com\nskysauto88@yahoo.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1098,
    Name: "New Thong Hing Motor Sdn Bhd",
    Address:
      "Lot 17502, Jalan 4\nTaman Selayang Baru Industrial Area\n68100 Batu Caves\nSelangor",
    Tel: "03- 6125 2828",
    Fax: "03- 6136 3639",
    Email: "newthmotor@gmail.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1099,
    Name: "Utama Motor Workshop ( Selangor ) Sdn Bhd",
    Address:
      "Lot 8860. Jalan Kim Chuan\nPandamaran\n42000 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3166 1999\n03- 3165 8820",
    Fax: "03- 3168 5229",
    Email: "umwssb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1100,
    Name: "Weng Oon Auto Sdn Bhd",
    Address:
      "50, Jalan Mas Jaya 2\nKawasan Perindustrian Mas Jaya\nOff Jalan Hulu Langat\n43200 Cheras\nSelangor Darul Ehsan",
    Tel: "03- 9075 1133",
    Fax: "03- 9076 7068",
    Email: "mah@wengoon.com.my\nsherene@wengoon.com.my",
    Area: "CHERAS",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1101,
    Name: "Auto Windshields Sdn Bhd (HQ)",
    Address:
      "No 4 Kompleks Letak Kereta\nPersiaran Puteri 1\nBandar Puteri\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 805 21222\n016- 745 8899",
    Fax: null,
    Email: "autowinds@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1102,
    Name: "C & R Auto Glass Sdn Bhd",
    Address:
      "No.6 Lorong PJS 7/20A\nBandar Sunway\n46150 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5632 8649\n012- 630 1578",
    Fax: "03- 5637 8894",
    Email: "cnrautoglass@hotmail.my",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1103,
    Name: "C.T.S Workshop Sdn Bhd",
    Address:
      "No.8 & 10, Jalan TS 6/6\nTaman Industri Subang\n47510 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 56328655\n019- 2138146",
    Fax: "03- 56329044",
    Email: "yongsn-222@yahoo.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1104,
    Name: "CF Windscreen & Tint Specialist Sdn Bhd",
    Address:
      "No 40-G, Jalan Puteri 2/2\nBandar Puteri\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 8066 8566\n016- 320 3230",
    Fax: null,
    Email: "cf.windscreen@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1105,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd (HQ)",
    Address:
      "No.7 Jalan Avenue 3\nAvenue Ampang\n68000 Ampang\nSelangor Darul Ehsan",
    Tel: "03- 4296 2366\n03- 4280 5379\n016- 975 9666",
    Fax: null,
    Email: "dolwa-ampang@hotmail.com",
    Area: "AMPANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1106,
    Name: "Elegance Windscreen Specialist Sdn Bhd",
    Address:
      "No. 10A, Lorong Sungai Rasah 27\nOff Jalan Batu Tiga Lama, Kawasan 16\n41300 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2818\n019- 270 6633",
    Fax: "03- 3342 7488",
    Email: "elegance.specialist@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1107,
    Name: "Gallant Motors Sdn Bhd",
    Address:
      "No. 35, 36 & 37, Jalan Emas 14\nBandar Sungai Emas, Sungai Manggis\n42700 Banting\nSelangor Darul Ehsan",
    Tel: "03- 3181 2088\n03- 3187 9776",
    Fax: "03- 3187 3016",
    Email: "gallantmotors@gmail.com",
    Area: "BANTING",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1108,
    Name: "Global Windscreen Sdn Bhd",
    Address:
      "No. 3-1-3A, Jalan Rawang Mutiara 1\nRawang Mutiara Business Centre\n48000 Rawang\nSelangor Darul Ehsan",
    Tel: "019- 262 0302",
    Fax: "03- 6091 4505",
    Email: "globalwindscreen@gmail.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1109,
    Name: "Koon Lee Auto Glass Sdn Bhd (HQ)",
    Address:
      "No 35, Ground Floor\nJalan Bayu Tinggi 1A\nBandar Bayu Tinggi\n41200 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3318 6050\n016- 620 3485",
    Fax: null,
    Email: "koonleeautoglass@hotmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1110,
    Name: "Mobile Windscreen Sdn Bhd (HQ)",
    Address:
      "No. 3-G, 2A-G, 2A-1, 2A-3, 5-G \nLorong Tiara 1B\nBandar Baru Klang\n41150 Klang\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1111,
    Name: "PS Windscreen Specialist Service",
    Address:
      "Lot 10905, Jalan Teluk Batu 36/1\nAMJ Industrial Area\nKampung Jawa, Section 36\n40470 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5162 8550\n012- 238 8970\n016- 225 8970",
    Fax: "03- 5162 8737",
    Email: "spswindscreen@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1112,
    Name: "Puchong Sunway Auto Glass Specialists Sdn Bhd",
    Address:
      "No. 23G Jalan Bandar 12\nPusat Bandar Puchong\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 5891 9018\n016- 238 1668",
    Fax: "03- 5891 9078",
    Email: "puchongsunway@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1113,
    Name: "Tai Poh Motor Sdn Bhd",
    Address:
      "2-G & 2-1, Jalan Lembah Jaya 4\nTaman Industri Lembah Jaya\n68000 Ampang\nSelangor Darul Ehsan",
    Tel: "03- 4270 9632\n016- 225 9603",
    Fax: "03- 4270 0573",
    Email: "taipohmotor@gmail.com",
    Area: "AMPANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1114,
    Name: "United Teh Auto Repair Sdn Bhd",
    Address:
      "No.3 Jalan 39 Kawasan 16\noff Jalan Dato Mohd Sidin \n(Jalan Connaught Bridge)\n41300 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3341 8309\n03- 3342 1613",
    Fax: "03- 3342 3418",
    Email: "ut@unitedtehauto.com.my",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1115,
    Name: "V Ar Auto Glasses",
    Address:
      "No 75 & 77 Jalan SBC 1\nTaman Sri Batu Caves\n68100 Batu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6188 2228",
    Fax: "03- 6184 2820",
    Email: "varautoglasses@yahoo.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1116,
    Name: "Voltex Windshield Services Centre",
    Address:
      "No. 20G, Jalan 8/35\nSeksyen 8, Seri Bangi\n43650 Bandar Baru Bangi\nSelangor Darul Ehsan",
    Tel: "03- 8926 1082",
    Fax: "03-8923 1082",
    Email: "voltexwindshield@yahoo.com",
    Area: "BANDAR BARU BANGI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1195,
    Name: "PG88 Windscreen Specialist Sdn Bhd",
    Address:
      "No.3, Jalan Juruanalisis U1/35\nKawasan Perindustrian Hicom, Seksyen U1\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5569 7727\n016- 922 5777",
    Fax: null,
    Email: "pg88_a@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1202,
    Name: "CF Windscreen & Tint Specialist Sdn Bhd",
    Address:
      "No. 17-G, Jalan Putra Perdana 2/1 \nTaman Putra Perdana\n47100 Puchong\nSelangor",
    Tel: "03- 8066 8566\n016- 320 3230",
    Fax: null,
    Email: "cf.windscreen@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1203,
    Name: "Chua Brothers Windscreen Specialist Sdn Bhd",
    Address:
      "Lot 1-10G, Ground Floor\nJalan Pahat G15/G, Seksyen 15\nPersiaran Selangor\n40100 Shah Alam\nSelangor",
    Tel: "03- 5524 3633\n012- 634 2799",
    Fax: null,
    Email: "cbwssa@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1205,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd",
    Address:
      "No.93A-G, Jalan Dataran Cheras\nDataran Perniagaan Cheras\n(Cheras Traders Square)\n43200 Balakong Cheras\nSelangor",
    Tel: "016- 378 9090\n016- 975 9666",
    Fax: null,
    Email: "info@dolwa.com.my",
    Area: "BALAKONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1207,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd",
    Address:
      "No.562, Jalan Samudra Utara 1\nTaman Samudra\n68100 Batu Caves\nSelangor",
    Tel: "016- 975 9666\n016- 378 9090",
    Fax: null,
    Email: "info@dolwa.com.my",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 1208,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd",
    Address: "No.57, Jalan SS 14/2\n47500 Subang Jaya\nSelangor",
    Tel: "03- 5612 8866\n03- 5612 8822\n014- 925 1883",
    Fax: null,
    Email: "info@dolwa.com.my",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1209,
    Name: "Dolwa Auto Glass (Ampang) Sdn Bhd",
    Address:
      "No.19 (Ground Floor)\nJalan SS 2/55\n47300 Petaling Jaya\nSelangor",
    Tel: "016- 378 9090\n014- 925 1883",
    Fax: null,
    Email: "info@dolwa.com.my",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1210,
    Name: "KL Auto Glass Services",
    Address:
      "No.11 (Ground Floor)\nJalan USJ 1/19\nTaman Subang Permai\n47600 Subang Jaya\nSelangor",
    Tel: "03- 5889 6611\n017- 316 6162",
    Fax: null,
    Email: "klautoglass88usj@gmail.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1211,
    Name: "Koon Lee Auto Glass Sdn Bhd",
    Address: "No.6-1, Jalan Merpati\nTanamera\n47650 Subang Jaya\nSelangor",
    Tel: "03- 5103 8849\n016- 2748 009",
    Fax: null,
    Email: "koonleeautoglass@hotmail.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1212,
    Name: "Koon Lee Auto Glass Sdn Bhd",
    Address:
      "T215 Jalan Teratai\nTaman Seri Telok Datok\n42700 Banting\nSelangor\n",
    Tel: "03- 3180 1523\n017- 382 7300",
    Fax: null,
    Email: "koonleeautoglass@hotmail.com",
    Area: "BANTING",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1215,
    Name: "Voltex Windshield Services Centre",
    Address:
      "No. 18G, Jalan Seri Mas 1\nTaman Perkasa\n43100 Hulu Langat\nSelangor",
    Tel: "03- 9021 3082",
    Fax: "03- 9021 3082",
    Email: "voltexwindshield@yahoo.com",
    Area: "HULU LANGAT",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1218,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "12-A-G, Jalan Tiara 2A/KU1\nBandar Baru Klang\n41150 Klang\nSelangor",
    Tel: "03- 3359 8725",
    Fax: null,
    Email: "nanmarklang@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1228,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "G-3, Jalan Puteri 4/6\nBandar Puteri Puchong\n47100 Puchong\nSelangor",
    Tel: "03- 8051 1601",
    Fax: null,
    Email: "nanmarpc@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1233,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 7-G, Jalan Bayu Tinggi 7\nTaman Bayu Tinggi\n41200 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1235,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 49-G, Jalan Permata 1/KS 09\nPusat Perniagaan Bestari\nTaman Perindustri\n42000 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1236,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 24-G, Jalan Sungai Keramat 1A\nSri Mewah Light Industri Factory\nBatu 5, Jalan Kapar\n41200 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1237,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 198-G\nJalan Sultan Abdul Samad \n42700 Banting \nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "BANTING",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1238,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 74-G\nJalan Renang 13/26\nSeksyen 13\n40100 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1239,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 64-G\nJalan Setia Gemilang BM U13/BM \nBandar Setia Alam\n40170 Shah Alam\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1240,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "2-39-01, No. 14-G\nPersiaran Anggerik Vanilla \nKota Kemuning Sek 31\n40460 Shah Alam\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1241,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. F-G-47, Block F\nJalan PJU 1A/3\nTaipan Damansara 2\nParcel 1, Ara Damansara \n47301 Petaling Jaya\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1242,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "The Strand, No.33-G, \nJalan PJU 5/20\nKota Damansara\n47810 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com\n",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1243,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 63, Jalan PJS 11/7\nBandar Sunway\n47500 Subang Jaya\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1244,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 2A-G, Jalan Bandar 20\nPusat Bandar Puchong\n47160 Puchong\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1245,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 19-G, Jalan Equine 10\nTaman Equine\n43300 Seri Kembangan\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "SERI KEMBANGAN",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1246,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 7-G, Jalan Ria 1\nKawasan Perindustrian Ria\n43000 Kajang\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KAJANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1247,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 79-G, Jalan 8/1, Seksyen 8\nBandar Baru Bangi\n43650 Bangi\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "BANGI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1248,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No.772, Jalan Besar\nPekan Dengkil\n43800 Dengkil\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "DENGKIL",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1249,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 77-G, Jalan Bandar Rawang 2\nBandar Baru Rawang\n48000 Rawang\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1250,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 63-G, Jalan Meranti 1A\n44300 Batang Kali\nSelangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "BATANG KALI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1251,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 29-G, Adenium Business Centre \nJalan Adenium 2G/7\n48300 Bukit Beruntung \nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com\n",
    Area: "BUKIT BERUNTUNG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1252,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 9-G, Jalan PPAJ 3/1\nPusat Perdagangan Alam Jaya\nBandar Puncak Alam\n 42300 Selangor Darul Ehsan\n",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "PUNCAK ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1305,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 7048(A), Batu 14 ½\nJalan Klang Banting\n42600 Jenjarom\nSelangor Darul Ehsan\n",
    Tel: "016- 262 5069",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "JENJAROM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1306,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.10, Lorong 51A/227A\nSeksyen 51A\n46100 Petaling Jaya\nSelangor Darul Ehsan\n",
    Tel: "012- 273 3994",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1307,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "20, Jalan SS25/34\nMayang Industrial Park\n47301 Petaling Jaya\nSelangor Darul Ehsan\n",
    Tel: "016- 212 8690 ",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1308,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 3468 - A6 & A7 \nJalan Puchong 7 1/2 Batu\n47100 Puchong \nSelangor Darul Ehsan",
    Tel: "012- 300 5816",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1309,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.41, Jalan Utama 1/1\nTaman Perindustrian Puchong Utama\n47100 Puchong\nSelangor Darul Ehsan",
    Tel: "016- 328 7217",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PUCHONG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1310,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No 21, Jalan 1, Seksyen 1\nTaman Bukit Rawang Jaya \n48000 Rawang\nSelangor Darul Ehsan",
    Tel: "019- 317 2990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1311,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "L6.4446, Janan Manickavasagam\nTaman Tan Sri Manickavasagam \n43500 Semenyih\nSelangor Darul Ehsan\n",
    Tel: "012- 313 6785",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SEMENYIH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1312,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "245-C, Jalan Kolej\n43300 Seri Kembangan \nSelangor Darul Ehsan\n",
    Tel: "016- 229 2990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SERI KEMBANGAN",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1313,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "36, Jalan Opera G U2/G \nTaman TTDI Jaya\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "012- 386 8518",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com\n",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1314,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 7734-G\nJalan Pekan Subang\nSeksyen U6\n40150 Shah Alam\nSelangor\n",
    Tel: "012- 383 3630",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1315,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 37, Jalan Tanjung Rhu 30/165\n40150 Shah Alam\nSelangor Darul Ehsan",
    Tel: "012- 311 2700",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1316,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 3007, Jalan Besar\nSungai Buloh\nKampung Paya Jaras Tengah\n47000 Sungai Buloh\nSelangor Darul Ehsan\n",
    Tel: "016- 201 2991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SUNGAI BULOH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1317,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.6, Lebuhraya Persekutuan\nBatu 10\n47300 Sungai Way\nSelangor Darul Ehsan",
    Tel: "014- 3879531",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SUNGAI WAY",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1318,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.35, Jalan Satu\nTaman Tanjong Karang\n45500 Tanjong Karang\nSelangor Darul Ehsan",
    Tel: "012- 289 1791",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "TANJONG KARANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1334,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 48, Jalan Rhu 1\nTaman Rhu Permai\n45000 Kuala Selangor\nSelangor Darul Ehsan",
    Tel: "019- 750 3991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA SELANGOR",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1335,
    Name: "Dr Cermin Sdn Bhd",
    Address: "93, Jalan Besar\n45400 Sekinchan\nSelangor Darul Ehsan",
    Tel: "019- 286 3992",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SEKINCHAN",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1336,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "17, Jalan Jernang Jaya 1\nTaman Jernang Jaya\n43650 Bandar Baru Bangi\nSelangor Darul Ehsan",
    Tel: "019- 269 5991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BANDAR BARU BANGI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1337,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "182-B, Jalan Bunga Raya\n45300 Sungai Besar\nSelangor Darul Ehsan",
    Tel: "019- 264 6991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "SUNGAI BESAR",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1351,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 5-G, Jalan Tiara 2B\nBandar Baru Klang\n41150 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1352,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 101, Jalan Cokmar 1\nMutiara Bukit Raja\nOff Jalan Meru \n41050 Klang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1353,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 43A, Jalan Peninsula Utama 1\nPeninsula Park\n45000 Kuala Selangor\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KUALA SELANGOR",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1354,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "21, Jalan SS4D/2\nKelana Jaya\n47301 Petaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1355,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 65, Jalan Mahkota Residence 1\nMahkota Residence\nBandar Mahkota Cheras\n43200 Cheras\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "CHERAS",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1356,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 16, Jalan Bersatu 10\nTaman Bersatu\n48000 Rawang\nSelangor Darul Ehsan",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1369,
    Name: "Chua Brothers Windscreen Specialist Sdn Bhd",
    Address:
      "No 45, Jalan TSB 10A\nTaman Industri\n47000 Sungai Buloh, Selangor",
    Tel: "03- 6143 4133\n016- 221 9991",
    Fax: null,
    Email: "cbwssb@gmail.com",
    Area: "SUNGAI BULOH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1371,
    Name: "DSG Auto Glass Sdn Bhd",
    Address:
      "No 3 (Ground Floor)\nJalan Tiara, 2D/KU1\nPusat Perniagaan BBK\nBandar Baru Klang\n41150 Klang, Selangor",
    Tel: "03- 3343 1281\n012- 649 9688",
    Fax: null,
    Email: "dsgklang2011@hotmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1372,
    Name: "DSG Auto Glass Sdn Bhd",
    Address:
      "No 11, Jalan Bandar Rawang 11\nBandar Baru Rawang\n48000 Rawang, Selangor",
    Tel: "016- 332 7853",
    Fax: null,
    Email: "dsgrawang@gmail.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1374,
    Name: "Koon Lee Auto Glass Sdn Bhd",
    Address: "No.202-G, Jalan Pekan Meru\n41050 Klang \nSelangor Darul Ehsan",
    Tel: "03- 3359 1148\n016- 311 7123",
    Fax: "03- 3359 1148",
    Email: "koonleeautoglass@hotmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1375,
    Name: "Koon Lee Auto Glass Sdn Bhd",
    Address:
      "No.53, Jalan Mohd Tahir 8/KS02\nTaman Saujana\nOff Sungai Jati\n41200 Klang \nSelangor Darul Ehsan",
    Tel: "03- 3381 3670\n016- 968 0805",
    Fax: "03- 3381 3670",
    Email: "koonleeautoglass@hotmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1376,
    Name: "Koon Lee Auto Glass Sdn Bhd",
    Address:
      "No.5217, Komplek Hasby\nPersiaran Raja Muda Musa\n42000 Pelabuhan Klang \nSelangor Darul Ehsan",
    Tel: "03- 3163 0661\n016- 250 3081",
    Fax: "03- 3163 0661",
    Email: "koonleeautoglass@hotmail.com",
    Area: "PELABUHAN KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1378,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "No. 11A, Jalan SS 19/6\n47500 Subang Jaya\nSelangor Darul Ehsan",
    Tel: "03- 5611 7335",
    Fax: null,
    Email: "nanmarsbj@gmail.com",
    Area: "SUBANG JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 1088,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.7, Lot PT. 9253\n(Tkt Bawah) Jalan Paka Kerteh\n23100 Paka Dungun\nTerengganu\n",
    Tel: "019- 939 6991",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PAKA DUNGUN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1089,
    Name: "Yoong Lee Car-Tech Sdn Bhd",
    Address:
      "T 2138K, Kawasan Perindustrian Chendering\n21080 Kuala Terengganu\nTerengganu",
    Tel: "09- 917 1407\n09- 6172 407",
    Fax: "09- 6175 407",
    Email: "yoonglee01@yahoo.com.my",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1090,
    Name: "Bengkel Kereta Kemaman Sdn Bhd",
    Address:
      "Lot 6273, Kawasan Perindustrian Jakar 1\n24000 Kemaman\nTerengganu",
    Tel: "09- 859 2067",
    Fax: "09- 859 3677",
    Email: "bkk_spray@hotmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1091,
    Name: "Brigstone Auto Maju Workshop Sdn Bhd",
    Address: "Lot. 3048 Batu 5 ½, Jalan Paka\n23000 Dungun\nTerengganu",
    Tel: "09- 845 3803\n09- 845 8268",
    Fax: "09- 845 3801",
    Email: "automaju88@gmail.com",
    Area: "DUNGUN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1092,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 743, Jalan Chendering\nKg Chendering\n21080 Kuala Terengganu\nTerengganu",
    Tel: "010- 9098 575",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1093,
    Name: "East Coast Spray & Repair Sdn Bhd",
    Address:
      "No.7 Lot 5820\nKawasan Perindustrian Jakar ll\n24000 Kemaman\nTerengganu",
    Tel: "09- 859 5228\n09- 858 5788",
    Fax: null,
    Email: "estcoastsr@gmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1200,
    Name: "Car Home (M) Sdn Bhd",
    Address:
      "Lot PT 3674-A Tingkat Bawah\nGong Kapas \nJalan Sultan Mohammad\n21100 Kuala Terengganu\nTerengganu",
    Tel: "016- 897 3612",
    Fax: null,
    Email: "carhomemalaysia@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1201,
    Name: "Car Home (M) Sdn Bhd",
    Address: "Jalan Cukai Utama 1\nTaman Cukai Utama\n24000 Chukai\nTerengganu",
    Tel: "019- 985 8838",
    Fax: null,
    Email: "carhomemalaysia@gmail.com",
    Area: "CHUKAI",
    Status: 0,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1220,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address: "30-E, Jalan Hiliran\n20300 Kuala Terengganu\nTerengganu",
    Tel: "09- 620 2169",
    Fax: null,
    Email: "nanmarktg@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1319,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.16, Jalan Besar\nKampung Seberang Jerteh\n22000 Besut\nTerengganu",
    Tel: "016- 207 3997",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "BESUT",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1320,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "PtT10368, Tingkat Bawah\nJalan Paka, Kg Batu 5\nTaman Bukit Bauk 1 \n23000 Dungun\nTerengganu",
    Tel: "016- 920 3981",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "DUNGUN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1321,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No.2310, Jalan Kubang Kurus\nTaman Bersekutu \n24000 Chukai\nTerengganu",
    Tel: "016- 920 6990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1322,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "683A, Jalan Sultan Mohang Gong Kapas\n21000 Kuala Terengganu\nTerengganu\n",
    Tel: "019- 935 3990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1323,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "No. 2569C, Jalan Tengku Mizan\nPak Katak \n21200 Kuala Terengganu\nTerengganu\n",
    Tel: "012- 912 2732",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1324,
    Name: "Dr Cermin Sdn Bhd",
    Address: "Lot.1692, Pengadang Baru\n20050 Kuala Terengganu \nTerengganu\n",
    Tel: "019- 986 8990",
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1339,
    Name: "Dr Cermin Sdn Bhd",
    Address:
      "Lot 420-1, Jalan Setiu-Jerteh \nKampung Balik Bukit\n22100 Permaisuri\nTerengganu",
    Tel: null,
    Fax: null,
    Email: "sharon@drcermin.com\ndrcermin.pr@gmail.com",
    Area: "PERMAISURI",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1360,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "No. 221-D, Ladang Sekolah\nJalan Sultan Zainal Abidin\n20000 Kuala Terengganu\nTerengganu",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1361,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "K 13 (GF & 1st Floor) \nJalan Baru Kampung Pak Sabah\n23000 Dungun\nTerengganu",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "DUNGUN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1362,
    Name: "Mobile Windscreen Sdn Bhd",
    Address:
      "PT 21689, Tingkat Bawah\nJalan Kubang Kurus\n24000 Kemaman\nTerengganu",
    Tel: "03- 3343 2333\n013- 833 3038\n012- 327 2728",
    Fax: null,
    Email: "mobile_windscreen@yahoo.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
  {
    "Unique ID": 1365,
    Name: "Pacific Auto Care",
    Address:
      "No. 10728, Tingkat Bawah, Blok B\nTaman Chukai Utama, Fasa 4\n24000 Kemaman, Terengganu",
    Tel: "09- 8589055",
    Fax: null,
    Email: "autocare.pacific@gmail.com",
    Area: "KEMAMAN",
    Status: 1,
    State: "Terrenganu",
  },
];
